import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from 'components/Typography';
import useUser from 'hooks/useUser';
import connect from 'components/icons/connect.svg';
import heartSrc from 'components/icons/heart.svg';
import { logReferralDashboardViewed } from '@alltrails/analytics/amplitudeFunctions';
import * as styles from './YourInvitesModal.module.scss';

// Mobile null: https://app.zeplin.io/project/62193b4e4e72bf62a25f2093/screen/62193c40412bf5649e4a25fc
// Desktop: https://app.zeplin.io/project/62193b4e4e72bf62a25f2093/screen/62193f6609b9d36100abd70f
// Desktop null: https://app.zeplin.io/project/62193b4e4e72bf62a25f2093/screen/62193f671668655aca078fb7

export default function YourInvitesModal() {
  const { trees_planted } = useUser();

  useEffect(() => {
    logReferralDashboardViewed();
  }, []);

  return (
    <Typography className={styles.content} component="div" mt="2xl">
      {trees_planted === 0 ? <img alt="" className={styles.container} src={connect} /> : <img alt="" className={styles.heart} src={heartSrc} />}
      <Typography component="div" mb="12" variant="xxxltitle">
        {trees_planted}
      </Typography>
      <Typography component="div" mb="24" variant="title1">
        <FormattedMessage
          defaultMessage="{count, plural, one {Tree} other {Trees}} Planted"
          values={{
            count: trees_planted
          }}
        />
      </Typography>
      {trees_planted > 0 && (
        <Typography component="div">
          <FormattedMessage defaultMessage="Your trees support the One Tree Planted mission to restore damage from wildfires and deforestation worldwide." />
        </Typography>
      )}
    </Typography>
  );
}
